import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  InputNumber,
  Button,
  Select,
  Upload,
  Divider,
} from 'antd';
import {
  ArrowsAltOutlined,
  LoadingOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form';
import { Document, Page } from 'react-pdf';
import styles from '../style.less';
import { UPLOAD_DOC_URL } from 'utils/config';
import { readFile } from 'services/ocrservice';
import { findSIBeneficiary } from 'services/thirdParty';
import { UploadDocumentFile } from 'utils/request';

export type tabImportInvoiceProps = {
  form: FormInstance;
};
const { Option } = Select;

const TabImportInvoice = ({ form }: tabImportInvoiceProps) => {
  const [state, setstate] = useState<any>({
    activeKey: '1',
    loadingUpload: false,
    sidetail: [],
    suppInvoiceLines: [],
    suppInvoiceSchedule: [],
    fwDisplay: [],
    accountingreference: '',
    documentList: [],
    NettingView: [],
    ACCEVENTLIST: [],
    ACCENTRIESLIST: [],
    ACCEVENT: [],
    accevent: '',
    accmodel: '',
    PARTAXLIST: [],
    SILCAT: [],
    payBeneficiaryList: [],
    errorFields: [],
    multiContrat: false,
    sistatus: 'INIT',
    tpidclient: '',
    tpidsupplier: '',
    ctrid: '',
    ctreference: '',
    fetchingSupplier: false,
    listSupplier: [],
    valueSupplier: [],
    fetchingAsset: false,
    listAsset: [],
    valueAsset: [],
    totalLinesNet: 0,
    totalLinesTax: 0,
    totalLinesGross: 0,
    totalSIS: 0,
    disableSItype: false,
    siPageTitle: 'New Supplier Invoice...',
    fileName: '',
    previewVisible: false,
    previewImage: '',
    previewTitle: '',
    numPages: null,
    pageNumber: 1,
    scale: 1,
    isPDF: false,
    fileContent: '',
    invoiceModel: '',
    disableExtract: true,
    disableConvert: true,
    displayTabUpload: false,
    ModuleModalObject: '',
    titleModalObject: '',
    visibleModalObject: false,
  });

  const handlePreviewImport = (fileurl: any) => {
    const ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);
    if (ext === 'pdf') {
      setstate({ ...state, isPDF: true });
      state.isPDF = true;
    } else {
      state.isPDF = false;
    }
    setstate({ ...state, previewImage: fileurl });
    state.previewImage = fileurl;

    state.previewTitle = fileurl.substring(fileurl.lastIndexOf('/') + 1);
  };

  const handleUploadImport = (info: any) => {
    if (info.file.status === 'uploading') {
      setstate({ ...state, loadingUpload: true });
      return;
    }
    if (info.file.status === 'done') {
      setstate({ ...state, loadingUpload: false, fileName: info.file.name });
      state.fileName = info.file.name;

      if (state.invoiceModel != null) {
        setstate({ ...state, disableExtract: false });
      } else {
        setstate({ ...state, disableExtract: true });
      }
      handlePreviewImport(UPLOAD_DOC_URL + state.fileName);
    }
  };
  const uploadButton2 = (
    <div>
      {state.loadingUpload ? <LoadingOutlined /> : <UploadOutlined />}
      &nbsp;Upload
    </div>
  );
  const selectModelChange = (value: any) => {
    setstate({ ...state, invoiceModel: value });

    state.invoiceModel = value;
    if (state.fileName != null) {
      setstate({ ...state, disableExtract: false });
    } else {
      setstate({ ...state, disableExtract: true });
    }
  };
  const extractData = () => {
    const params = { fileName: state.fileName };
    readFile(params).then((response) => {
      setstate({
        ...state,
        fileContent: response,
        disableConvert: false,
        disableExtract: true,
      });
    });
  };

  const handleChangeSupplier = (value: any) => {
    setstate({ ...state, tpidsupplier: value });
    findSIBeneficiary({tpid:value}).then((response: any) => {
      setstate({ ...state, payBeneficiaryList: response });
    });
  };
  const formatSamsungDate = (dt: any) => {
    if (dt != null) {
      const ldate = `${dt.substring(6, 10)}-${dt.substring(
        3,
        5
      )}-${dt.substring(0, 2)}`;
      return ldate;
    }
  };
  const handleSumsungImport = () => {
    setstate({ ...state, suppInvoiceLines: [], tpidsupplier: 1 });
    handleChangeSupplier(1);
    setstate({
      ...state,
      ctreference: state.fileContent.numevollis,
    });

    form.setFieldsValue({ sitype: 'ASSETF' });
    form.setFieldsValue({ tpidsupplier: 1 });
    form.setFieldsValue({
      tpidclient: state.fileContent.nomclient,
    });
    form.setFieldsValue({
      ctreference: state.fileContent.numevollis,
    });
    form.setFieldsValue({
      sidocreference: state.fileContent.numdocument,
    });
    const dtdoc = moment(
      formatSamsungDate(state.fileContent.datedocument),
      'YYYY-MM-DD'
    );
    form.setFieldsValue({ sidocdate: dtdoc });
    const dtcmd = moment(
      formatSamsungDate(state.fileContent.datecommande),
      'YYYY-MM-DD'
    );
    form.setFieldsValue({ orderdate: dtcmd });
    form.setFieldsValue({
      orderreference: state.fileContent.numcommande,
    });
    const dtliv = moment(
      formatSamsungDate(state.fileContent.datelivraison),
      'YYYY-MM-DD'
    );
    form.setFieldsValue({ deliverydate: dtliv });
    form.setFieldsValue({
      deliveryreference: state.fileContent.numbonlivraison,
    });
    let mttaxeServ = 0;
    let mttaxeAsset = 0;
    const mthtinit = parseFloat(
      state.fileContent.mthtinitial.replace('.', '').replace(',', '.')
    );
    const pourcremise = parseFloat(
      state.fileContent.pourcremise.replace('.', '').replace(',', '.')
    );
    const mthtapresremise = parseFloat(
      state.fileContent.mthtremise.replace('.', '').replace(',', '.')
    );
    const mthtassetAR = mthtinit * (1 - pourcremise / 100);
    const mthtServ = Math.round(mthtapresremise - mthtassetAR);
    mttaxeServ = mthtServ * 0.2;
    const mtttcServ = mttaxeServ + mthtServ; // Math.round(mthtServ*120/100,2);
    mttaxeAsset = parseFloat(String(mthtassetAR * 0.2));
    const mtttcAsset = parseFloat(String(mthtassetAR * 1.2));
    const mtecopart = parseFloat(
      state.fileContent.mtecopart.replace('.', '').replace(',', '.')
    );

    let suppInvoiceLines2 = state.suppInvoiceLines;
    // line 1 = Asset
    let newData = {
      silid: 1,
      siid: null,
      silorder: 1,
      silquantity: '1',
      siltype: 'ASSET',
      silcategory: '',
      ctrid: null,
      ctreference: state.fileContent.numevollis,
      assetid: null,
      sildescription: state.fileContent.description,
      sildescription2: null,
      silnetunitmount: mthtinit,
      sildiscountperc: pourcremise,
      silnetunitamountafterd: mthtassetAR,
      siltaxcode: 'NORM',
      silnettotalamount: mthtassetAR,
      silgrosstotalamount: mtttcAsset,
      siltaxtotalamount: mttaxeAsset,
      siltaxrate: '20',
    };
    suppInvoiceLines2 = [...suppInvoiceLines2, newData];

    // line 2 = Service
    newData = {
      silid: 2,
      siid: null,
      silorder: 2,
      silquantity: '1',
      siltype: 'FEES',
      silcategory: 'INSU',
      ctrid: null,
      ctreference: state.fileContent.numevollis,
      assetid: null,
      sildescription: 'RCP',
      sildescription2: null,
      silnetunitmount: mthtServ,
      sildiscountperc: 0,
      silnetunitamountafterd: mthtServ,
      siltaxcode: 'NORM',
      silnettotalamount: mthtServ,
      silgrosstotalamount: mtttcServ,
      siltaxtotalamount: mttaxeServ,
      siltaxrate: '20',
    };
    suppInvoiceLines2 = [...suppInvoiceLines2, newData];

    // line 3 = EcoPART
    newData = {
      silid: 3,
      siid: null,
      silorder: 3,
      silquantity: '1',
      siltype: 'FEES',
      silcategory: 'ECOPART',
      ctrid: null,
      ctreference: state.fileContent.numevollis,
      assetid: null,
      sildescription: 'ECO PARTICIPATION',
      sildescription2: null,
      silnetunitmount: mtecopart,
      sildiscountperc: 0,
      silnetunitamountafterd: mtecopart,
      siltaxcode: 'NOTAX',
      silnettotalamount: mtecopart,
      silgrosstotalamount: mtecopart,
      siltaxtotalamount: 0,
      siltaxrate: '0',
    };
    suppInvoiceLines2 = [...suppInvoiceLines2, newData];

    setstate({
      ...state,
      suppInvoiceLines: suppInvoiceLines2,
      activeKey: '2',
      totalLinesGross: mtttcAsset + mtttcServ + mtecopart,
      totalLinesNet: mthtServ + mthtassetAR + mtecopart,
      totalLinesTax: mttaxeAsset + mttaxeServ,
    });
  };

  const onChangepdfZoom = (value: any) => {
    setstate({ ...state, scale: value / 100 });
  };

  // const onDocumentLoadSuccess = (numPages: any) => {
  //   setstate({ ...state, numPages });
  // };

  return (
    <Card className={styles.card} bordered>
      <Row>
        <Col span={8}>
          Select a file : &nbsp;
          <Upload
            name="avatar"
            // action={UPLOAD_DOC_URL}
            customRequest={(data: any) => {
              UploadDocumentFile(data.file, form.getFieldValue('sireference'));
            }}
            onPreview={handlePreviewImport}
            onChange={(e) => handleUploadImport(e)}
          >
            <Button>{uploadButton2}</Button>
          </Upload>
        </Col>
        <Col span={8}>
          Select a Model : &nbsp;
          <Select
            style={{ marginLeft: '10px', width: '50%' }}
            onChange={selectModelChange}
          >
            <Option value="samsung">Samsung PDF</Option>
            <Option value="leclerc">Leclerc JPG</Option>
          </Select>
        </Col>

        <Col>
          <Button
            style={{ marginLeft: 10 }}
            icon={<ArrowsAltOutlined />}
            disabled={state.disableExtract}
            onClick={extractData}
          >
            {' '}
            Extract Data
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            icon={<ArrowsAltOutlined />}
            disabled={state.disableConvert}
            onClick={handleSumsungImport}
          >
            {' '}
            Confirm & Get it !
          </Button>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={16}>
          {state.isPDF && (
            <div>
              <Row>
                <Col>
                  <InputNumber
                    min={10}
                    max={200}
                    formatter={(value) => `${value}%`}
                    parser={(value: any) => value.replace('%', '')}
                    step={10}
                    defaultValue={100}
                    onChange={onChangepdfZoom}
                  />
                </Col>
              </Row>
              <Document
                file={state.previewImage}
                onLoadSuccess={state.onDocumentLoadSuccess}
              >
                <Page pageNumber={state.pageNumber} scale={state.scale} />
              </Document>
              <p>
                Page {state.pageNumber} of {state.numPages}
              </p>
            </div>
          )}

          {!state.isPDF && (
            <img
              alt={state.previewTitle}
              style={{ width: '100%' }}
              src={state.previewImage}
            />
          )}
        </Col>
        <Col span={8}>
          {state.invoiceModel === 'samsung' && (
            <div>
              <Row>
                <Col>Modèle Samsung PDF : </Col>
              </Row>
              <Divider />
              <Row>
                <Col style={{ color: 'blue' }}>Document# : &nbsp;</Col>
                <Col>{state.fileContent.numdocument}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Date Document# : &nbsp;</Col>
                <Col>{state.fileContent.datedocument}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Num Evollis# : &nbsp;</Col>
                <Col>{state.fileContent.numevollis}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Num Client# : &nbsp;</Col>
                <Col>{state.fileContent.numclient}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Nom client# : &nbsp;</Col>
                <Col>{state.fileContent.nomclient}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Adresse client# : &nbsp;</Col>
                <Col>{state.fileContent.adresseclient}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Num Commande# : &nbsp;</Col>
                <Col>{state.fileContent.numcommande}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Date Commande# : &nbsp;</Col>
                <Col>{state.fileContent.datecommande}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Num BL# : &nbsp;</Col>
                <Col>{state.fileContent.numbonlivraison}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Date Livraison# : &nbsp;</Col>
                <Col>{state.fileContent.datelivraison}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Description# : &nbsp;</Col>
                <Col>{state.fileContent.description}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>MT HT Initial# : &nbsp;</Col>
                <Col>{state.fileContent.mthtinitial}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>% Remise# : &nbsp;</Col>
                <Col>{state.fileContent.pourcremise}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>MT HT Remisé# : &nbsp;</Col>
                <Col>{state.fileContent.mthtremise}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>Eco Part# : &nbsp;</Col>
                <Col>{state.fileContent.mtecopart}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>MT Taxe# : &nbsp;</Col>
                <Col>{state.fileContent.mttaxe}</Col>
              </Row>
              <Row>
                <Col style={{ color: 'blue' }}>MT TTC# : &nbsp;</Col>
                <Col>{state.fileContent.mtttc}</Col>
              </Row>
            </div>
          )}

          {state.invoiceModel === 'leclerc' && (
            <div>
              <Row>
                <Col>Modèle Leclerc JPG : </Col>
              </Row>
              <Divider />
              <Row>
                <Col style={{ color: 'blue' }}>N°Leclerc # : &nbsp;</Col>
                <Col>à finaliser le mapping....</Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
    </Card>
  );
};
export default TabImportInvoice;
